import { environment } from '../environment';
import { storageHelper } from '../shared/helpers/storage';
import { appState } from '../shared/services/app/app.state';
import { registerServiceWorker } from './registerServiceWorker';

export enum SW_MESSAGE_TYPE {
  skipWaitng = 'SKIP_WAITING',
  logOut = 'LOG_OUT',
  logOutFromOtherTab = 'LOG_OUT_FROM_OTHER_TAB',
}

export const appInit = () => {
  if ((import.meta.env.VITE_REACT_APP_ENV as keyof typeof environment) === 'development') {
    return;
  }

  registerServiceWorker();

  if ('serviceWorker' in navigator) {
    // Existing message listener
    navigator.serviceWorker.onmessage = (event) => {
      if (event.data?.type === SW_MESSAGE_TYPE.logOutFromOtherTab) {
        appState.pub.logOutFromOtherTab();
      }
    };

    // Add controllerchange listener
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      const sw = storageHelper.local.getItem('SW') as LS_SW;
      if (sw) {
        sw.updated = true;
        storageHelper.local.setItem('SW', sw);
      } else {
        storageHelper.local.setItem('SW', {
          updated: true,
          navigateTo: '',
        } as LS_SW);
      }

      sessionStorage.clear();
      window.location.reload();
    });
  }
};
export interface LS_SW {
  updated: boolean;
  navigateTo: string;
}
